/* eslint-disable */
import * as Types from '../../types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from 'graphql-tag';
export type ActiveInvestingEntityPermissionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ActiveInvestingEntityPermissionsQuery = { __typename: 'Query', account?: { __typename: 'Account', id: string, activeInvestingEntity?: { __typename: 'InvestingEntity', id: string, permissions?: Array<string> | null } | null } | null };

export type SelectedInvestingEntityPermissionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SelectedInvestingEntityPermissionsQuery = { __typename: 'Query', account?: { __typename: 'Account', id: string, investingEntities?: Array<{ __typename: 'InvestingEntity', id: string, permissions?: Array<string> | null }> | null } | null };


export const ActiveInvestingEntityPermissionsDocument = gql`
    query ActiveInvestingEntityPermissions {
  account {
    id
    activeInvestingEntity {
      id
      permissions
    }
  }
}
    ` as unknown as DocumentNode<ActiveInvestingEntityPermissionsQuery, ActiveInvestingEntityPermissionsQueryVariables>;
export const SelectedInvestingEntityPermissionsDocument = gql`
    query SelectedInvestingEntityPermissions {
  account {
    id
    investingEntities {
      id
      permissions
    }
  }
}
    ` as unknown as DocumentNode<SelectedInvestingEntityPermissionsQuery, SelectedInvestingEntityPermissionsQueryVariables>;